import axios from 'axios';

// API 配置 - Railway 整合部署使用相對路徑
// 在開發環境中，默認使用 localhost:3001
// 在生產環境中，使用環境變量指定的 API URL
const API_BASE_URL = process.env.REACT_APP_API_URL || '';

// 設置 axios 默認 baseURL（加上 /api 前綴，因為舊的 API Client 端點不含 /api）
axios.defaults.baseURL = `${API_BASE_URL}/api`;

export const API_CONFIG = {
  BASE_URL: API_BASE_URL,
  ENDPOINTS: {
    // 認證
    AUTH: '/api/auth',
    LOGIN: '/api/auth/login',
    REGISTER: '/api/auth/register',

    // 帳號管理
    ACCOUNTS: '/api/user/social-accounts',
    ACCOUNTS_PRECREATE: '/api/user/social-accounts/pre-create',

    // Threads API
    THREADS: '/api/threads/posts',
    PUBLIC_THREADS: '/api/threads/public',
    THREADS_STATUS: '/api/threads/public/status',
    THREADS_PUBLISH: '/api/threads/public/posts/schedule/publish',

    // 其他 API
    ARTICLES: '/api/content/articles',
    MEDIA: '/api/assets/media',
    CONTENT: '/api/content',
    CALENDAR: '/api/content/calendar'
  }
};

// API URL 轉換器 - 將相對路徑轉為完整 URL
export const getApiUrl = (path) => {
  if (path.startsWith('http')) {
    return path; // 已經是完整 URL
  }
  return `${API_BASE_URL}${path}`;
};

// API 請求 helper
export const apiRequest = async (endpoint, options = {}) => {
  const url = getApiUrl(endpoint);
  const token = localStorage.getItem('token');

  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${await window.__getUserIdToken()}` })
    }
  };

  const config = {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultOptions.headers,
      ...options.headers
    }
  };

  try {
    const response = await fetch(url, config);
    return response;
  } catch (error) {
    console.error('API Request Error:', error);
    throw error;
  }
};

// 全局 fetch 覆蓋 - 自動轉換 API 路徑
const originalFetch = window.fetch;
window.fetch = function (url, options = {}) {
  if (typeof url === 'string' && url.startsWith('/api/')) {
    url = getApiUrl(url);
  }
  return originalFetch.call(this, url, options);
};

export default API_CONFIG;